import * as React from 'react';
import * as _ from 'lodash';
import { IListItem, IContactForList, IContactEntityTypePositions, ICenterBase, IUser } from '@nkr/models/index';
import { ContactEntityType, OrganType } from '@nkr/enums/index';
import { GridApi, GridReadyEvent, FirstDataRenderedEvent } from 'ag-grid-community';
import { FormControl, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import CenterGrid from './grid';
import Delete from '../delete';
import HardDelete from '../hard-delete';
import { IFilters } from '../filters';
import { Fragment } from 'react';

interface IProps {
    data: IContactForList[],
    centers: ICenterBase[],
    contactEntityTypes: IListItem[],
    entityTypePositions: IContactEntityTypePositions[],
    types: IListItem[],
    centerId: number,
    filters: IFilters,
    showDeleted: boolean,
    currentUser?: IUser,
    organType: OrganType,
    leadCoordinatorId: number,
    onFilterChange: (filters: IFilters) => void,
    onShowDeletedChange: (showDeleted: boolean) => void,
    onExport: () => void,
    onDelete: (contactId: number) => void,
    onHardDelete: (contactId: number) => void
}

interface IState {
    showDeleted: boolean,
    delete: {
        show: boolean,
        data: IContactForList
    },
    hardDelete: {
        show: boolean,
        data: IContactForList
    },
    context: any,
    gridApi: GridApi,
    canHardDelete: boolean,
    permissionLoading: boolean
}

class CenterList extends React.Component<IProps, IState> {
    readonly state: IState = {
        showDeleted: false,
        delete: {
            show: false,
            data: null
        },
        hardDelete: {
            show: false,
            data: null
        },
        context: { componentParent: this },
        gridApi: null,
        canHardDelete: false,
        permissionLoading: true
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    getFilteredData = () => {
        let d = this.props.data.filter(item => {
            let role = this.props.filters.centerRole > 0 ? item.positions.filter(x => x.id == this.props.filters.centerRole).length > 0 : true;
            let search = this.props.filters.search != '' ? (item.firstName + ' ' + item.lastName).toUpperCase().indexOf(this.props.filters.search.toUpperCase()) >= 0 : true;
            let deleted = this.props.showDeleted ? true : !item.isDeleted;

            return search && role && deleted;
        });

        return d;
    }

    getGroupList = () => {
        let groupList = this.props.entityTypePositions.filter(x => x.entityTypeId == ContactEntityType.Center);

        if (this.props.organType == OrganType.Liver) {
            groupList = groupList.filter(x => x.organType != OrganType.Kidney);
        }

        return groupList.map(group => {
            group.positions = _.sortBy(group.positions, item => item.description);
            return group;
        });
    }

    handleRoleChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let filters = _.cloneDeep(this.props.filters);
        filters.centerRole = parseInt(e.currentTarget.value);

        this.props.onFilterChange(filters);
    }

    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let filters = _.cloneDeep(this.props.filters);
        filters.search = e.currentTarget.value;

        this.props.onFilterChange(filters);
    }

    handleShowDeleted = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let showDeleted = e.currentTarget.value == '1';

        this.setState({
            showDeleted
        });

        this.props.onShowDeletedChange(showDeleted);
    }

    handleReset = () => {
        let filters: IFilters = {
            centerId: 0,
            contactEntityTypeId: 0,
            search: '',
            centerRole: 0,
            adminRoles: []
        };

        this.props.onFilterChange(filters);
    }

    handleExport = () => {
        this.props.onExport();
    }

    handleAdd = () => {
        window.location.href = `/center/${this.props.centerId}/profile/add-contact`;
    }

    handleMenuSelection = (eventKey: number, contactId: number) => {
        if (eventKey == 1) {
            window.location.href = `/center/${this.props.centerId}/profile/edit-contact/${contactId}`;
        }

        if (eventKey == 2) {
            let contact = this.props.data.find(x => x.id == contactId);

            this.setState({
                delete: {
                    show: true,
                    data: contact
                }
            });
        }

        if (eventKey == 3) {
            let contact = this.props.data.find(x => x.id == contactId);

            this.setState({
                hardDelete: {
                    show: true,
                    data: contact
                }
            });
        }
    }

    handleCancelDelete = () => {
        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    handleDeleteContact = () => {
        let contactId = this.state.delete.data.id;

        this.setState({
            delete: {
                show: false,
                data: null
            }
        }, () => {
            this.props.onDelete(contactId);
        });
    }

    handleHardDeleteContact = () => {
        let contactId = this.state.hardDelete.data.id;

        this.setState({
            hardDelete: {
                show: false,
                data: null
            }
        }, () => {
            this.props.onHardDelete(contactId);
        });
    }

    handleCancelHardDelete = () => {
        this.setState({
            hardDelete: {
                show: false,
                data: null
            }
        });
    }

    render = () => {
        const data = this.getFilteredData();
        const groupList = this.getGroupList();

        return (
            <div style={{ paddingBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                            <div>Search:&nbsp;</div>
                            <FormControl
                                style={{ width: 125 }}
                                placeholder='Search by name...'
                                value={this.props.filters.search}
                                onChange={this.handleSearchChange}
                            />
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                            <div>Role:&nbsp;</div>
                            <div>
                                <FormControl
                                    componentClass='select'
                                    value={this.props.filters.centerRole}
                                    onChange={this.handleRoleChange}
                                >
                                    <option value={0}>- Any -</option>

                                    {groupList.length > 1 && groupList.map((group, index) =>
                                        <Fragment key={'role-group-' + index}>
                                            <optgroup label={group.entityType}>
                                                {group.positions.map((position, positionIndex) =>
                                                    <option key={'role-group-item-' + positionIndex} value={position.id}>{position.description}</option>
                                                )}
                                            </optgroup>
                                        </Fragment>
                                    )}

                                    {groupList.length == 1 && groupList.map((group, index) =>
                                        <Fragment key={'role-group-' + index}>
                                            {group.positions.map((position, positionIndex) =>
                                                <option key={'role-group-item-' + positionIndex} value={position.id}>{position.description}</option>
                                            )}
                                        </Fragment>
                                    )}
                                </FormControl>
                            </div>
                        </div>

                        {this.props.currentUser?.canHardDelete && (
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 15 }}>
                                <div style={{ marginRight: 5 }}>Show Deleted:&nbsp;</div>
                                <FormControl
                                    componentClass='select'
                                    style={{ width: 'initial' }}
                                    value={this.state.showDeleted ? '1' : '0'}
                                    onChange={this.handleShowDeleted}
                                >
                                    <option value='0'>No</option>
                                    <option value='1'>Yes</option>
                                </FormControl>
                            </div>
                        )}

                        <Button bsStyle='danger' style={{ marginRight: 15 }} onClick={this.handleReset}>Reset Filters</Button>
                    </div>

                    <div>
                        <DropdownButton pullRight bsStyle='primary' title='Actions' id='Actions'>
                            <MenuItem onClick={this.handleAdd}>Add Contact</MenuItem>
                            <MenuItem onClick={this.handleExport}>Export Contacts</MenuItem>
                        </DropdownButton>
                    </div>
                </div>

                <CenterGrid
                    data={data}
                    canHardDelete={this.props.currentUser?.canHardDelete || false}
                    currentUser={this.props.currentUser}
                    centerId={this.props.centerId}
                    leadCoordinatorId={this.props.leadCoordinatorId}
                    onGridReady={this.onGridReady}
                    onFirstDataRendered={this.onFirstDataRendered}
                    onMenuSelection={this.handleMenuSelection}
                />

                <Delete
                    show={this.state.delete.show}
                    data={this.state.delete.data}
                    isCenter={true}
                    onDelete={this.handleDeleteContact}
                    onCancel={this.handleCancelDelete}
                />

                <HardDelete
                    show={this.state.hardDelete.show}
                    data={this.state.hardDelete.data}
                    isCenter={true}
                    onDelete={this.handleHardDeleteContact}
                    onCancel={this.handleCancelHardDelete}
                />
            </div>
        );
    }
}

export default CenterList;